/** @file GeneralSection: Settings > General: theme, language, pixel grid and reopening the last puppet. */
import type { ReactElement } from 'react';
import { applyTheme } from '../shell/applyTheme';
import type { LanguageName, ThemeName } from '../shell/editorSettings';
import { EDITOR_SETTINGS } from '../shell/editorSettings';
import { useSetting } from '../shell/useSetting';
import { useEditorStore } from '../state/useEditorStore';
import { Field } from '../ui-kit/Field';
import { Panel } from '../ui-kit/Panel';
import { Select } from '../ui-kit/Select';

const THEMES = [
  { value: 'dark', label: 'Dark' }, { value: 'darker', label: 'Darker (near black)' }, { value: 'light', label: 'Light (stub: main surfaces only)' },
];
const LANGUAGES = [{ value: 'en', label: 'English' }, { value: 'th', label: 'Thai (translation not written yet)' }];

/** Theme (applied at once), language (English only for now), ground grid at start, reopen the last puppet at start. */
export function GeneralSection(): ReactElement {
  const store = useEditorStore();
  const [theme, setTheme] = useSetting(EDITOR_SETTINGS.theme);
  const [language, setLanguage] = useSetting(EDITOR_SETTINGS.language);
  const [pixelGrid, setPixelGrid] = useSetting(EDITOR_SETTINGS.pixelGrid);
  const [reopen, setReopen] = useSetting(EDITOR_SETTINGS.reopenLast);
  return (
    <Panel title="General">
      <div className="p3-stack" style={{ padding: 12 }}>
        <Field label="Theme">
          <Select label="Theme" value={theme} options={THEMES} onChange={(v) => { setTheme(v as ThemeName); applyTheme(v as ThemeName); }} />
        </Field>
        <Field label="Language">
          <Select label="Language" value={language} options={LANGUAGES}
            onChange={(v) => { setLanguage(v as LanguageName); }} />
        </Field>
        <label className="p3-row">
          <input type="checkbox" aria-label="Pixel grid" checked={pixelGrid}
            onChange={(e) => { setPixelGrid(e.target.checked); store.getState().setCamera({ grid: e.target.checked }); }} />
          <span>Show the ground grid in the viewport (also View &gt; Grid)</span>
        </label>
        <label className="p3-row">
          <input type="checkbox" aria-label="Reopen the last puppet" checked={reopen} onChange={(e) => { setReopen(e.target.checked); }} />
          <span>Reopen the last puppet when the editor starts without a link</span>
        </label>
      </div>
    </Panel>
  );
}
